import {
  React,
  useRef, 
  useState,
  useEffect
} from 'react';

import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Select,
  Slider, 
  Tab,
  Typography ,
  MenuItem,
  InputLabel,
  FormControl,
} from '@mui/material';


const OperationModeDisplay = () =>{

	return ( 
		<Grid
            style={{border:"1px solid #cccccc", height:"269px",padding:"2px", margin:"1px"}}
            container
            spacing={1}
        >
      	<Grid 
         	item
     		lg={12}
            md={12}
            xl={12}
            xs={12}
        >
            <InputLabel shrink>Current Operation</InputLabel>
        </Grid>	
        <Grid 
         	item
     		lg={12}
            md={12}
            xl={12}
            xs={12}
        >
        <img
        	src="/static/images/operationModes/dish_manual.png"
        	 width="90%" height="70%"
      	/>
      	</Grid>	
        </Grid>
    );
}



OperationModeDisplay.propTypes = {
};
export default OperationModeDisplay;
